export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCcV-fD9A8YYrlXIWcAPUUsTX4RPIuUmuo",
    authDomain: "auth.dev.trumppostalert.com",
    projectId: "trump-post-alert-dev",
    storageBucket: "trump-post-alert-dev.firebasestorage.app",
    messagingSenderId: "967442990967",
    appId: "1:967442990967:web:a1d6ca8333abbd125c4372",
    measurementId: "G-2GC3VKC80V",
  },
  authProviders: {
    emailPassword: true,
    google: true,
    facebook: false,
    apple: false,
  },
  redirect: {
    allowHttpOnLocalhost: true,
    allowedHosts: ["localhost", "dev.trumppostalert.com"],
  },
  privacyPolicyUrl: "https://dev.trumppostalert.com/privacy-policy",
  termsOfUseUrl: "https://dev.trumppostalert.com/terms-of-use",
} as const;
